export default __webpack_public_path__ + "66d97324684ca02cc5c8ba49fe3e8852.svg";